export default {
  FETCH_BROKER_OWN(state, data) {
    state.brokerOwn = data
  }
}
